
// 初始化参数================

/*
{
  formData,
  cancelable: (!(cancelable in formData))? true : formData.cancelable,
  okable: (!(okable in formData))? true : formData.okable,
},
resolve,

 */

/*
  formData={
   Title:'零售价',
   Head:[{
     'Title':'存货名称',
     'Value':inventoryData.Name,
   }];
   Data:[{
      ControlType:'TextBox',
      FieldName:'TaxPrice',
      Title:'零售单价',
      IsRequired: true
    ],
    check ; 提交前校验
  }
*/

import {
  observable,
  action,
  runInAction
} from 'mobx';
import { ViewBase } from 'mutants-appfx';
import { Message } from 'tplus-components-touch'
import { i18n } from 'mutants-microfx';
import tools from '../util/tools';
import config from '../config'
const t = i18n.getFixedT(null, 'appfx');
const minDate = config.minDate;
class TextBoxModal extends ViewBase {
  get type() {
    return 'TextBoxModal';
  }

  @observable visible = false;
  @observable cancelable = false;
  @observable okable = false;
  @observable formData;
  @observable closeButton

  constructor(store, name) {
    super(store, name);
  }

  @action
  inputForm = ({ okable = true, cancelable = true, check, closeButton = true, update, ...formData }, out) => {
    this.formData = formData;
    this.cancelable = cancelable;
    this.okable = okable;
    this.out = out;
    this.check = check;
    this.update = update;
    this.closeButton = closeButton;
    this.show();
  }

  @action changeValue = async (field, value) => {
    const oldValue = field.Value;
    field.Value = value;
    if (!this.update) return;
    let that = this;
    let outData = this.makeOutData();
    const updatedResult = await this.update({
      formData: outData, updateProp: {
        name: field.FieldName,
        oldData: oldValue,
        newData: value
      }
    })
    if (updatedResult) {
      runInAction(() => {
        that.formData.Data.forEach((el) => {
          let key = el.FieldName;
          if (key in updatedResult) {
            let value = updatedResult[key];
            if (el.ControlType == 'DatePicker') {
              value = value && (value.getTime() > minDate.getTime()) ? value : null;
            }
            el.Value = value
          }
        })
        that.formData = { ...that.formData }
      })
    }
  }

  @action
  async okFun() {
    let outData = this.makeOutData();
    console.log("textbox输出数据", outData)
    if (this.check) {
      let checkData;
      checkData = await this.check(outData);
      if (checkData) {
        this.error(checkData)
        return
      }
    }
    this.out(outData);
    this.hide();
  }

  makeOutData = () => {
    let outData = {};
    this.formData.Data.forEach((el) => {
      if (el.ControlType === 'NumTextBox') {
        let value = el.Value
        if (!tools.isNull(value) && (value + "").endsWith('.')) {
          el.Value = value.substring(0, value.length - 1)
        }
      }
      outData[el.FieldName] = el.Value;
    })
    return outData;
  }

  @action
  error = (checkData) => {
    let type = checkData.type || 'warn';
    Message[type] && Message[type](t(checkData.Label))
  }

  @action
  ok = () => {
    this.okFun.call(this);
  }

  @action
  cancel = () => {
    if (this.cancelable) {
      this.hide();
      this.out()
    }
  }

  @action reset() {
    this.formData = null;
  }

  @action
  show = () => {
    this.visible = true;
  }

  @action
  hide = () => {
    this.visible = false;
    this.reset();
  }

  static fromJS(store, { TextBox: formData }) {
    return new TextBoxModal(store, 'TextBoxModal', '')
  }

}
export default TextBoxModal;